import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import ReactTable from 'react-table';
import Select from 'react-select';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import makeAnimated from 'react-select/lib/animated';
import update from 'immutability-helper';
import qs from 'query-string';

import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';

class SingleOrders extends Component {

    constructor() {
        super();

        this.toggleFilters = this.toggleFilters.bind(this);
        this._orderFocusChange = this.handleFocusChange('order').bind(this);
        this._orderDatesChange = this.handleDatesChange('order').bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.getOrders = this.getOrders.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.readQueryParams = this.readQueryParams.bind(this);

        this.state = {
            openFilters: true,
            filters: {
                order: {},
                payment: {
                },
                productList: [],
                orderStatusList: [],
                paymentStatusList: [{ value: 2 }, { value: 6 }, { value: 8 }]
            }
        }

        this.Configurations = new Configurations();

        this.productOptions = [
            { label: "Brasil Seikyo Português", value: "1" },
            { label: "Brasil Seikyo Japonês", value: "2" },
            { label: "Terceira Civilização", value: "3" },
            { label: "RDez", value: "4" },
            { label: "BS+", value: "5" },
            { label: "Brasil Seikyo Digital", value: "6" },
            { label: "Daibyakurenge", value: "7" }
        ]

        this.columns = [
            {
                Header: 'Pedido',
                accessor: 'numeroPedido',
                className: 'text-center pointer',
                width: 80
            },
            {
                Header: 'Tipo',
                accessor: 'tipoPedido',
                className: 'text-center pointer',
                width: 70,
                Cell: row => (<span className={`badge badge-${row.value === 'Individual' ? 'success' : 'info'}`}>{row.value}</span>)
            },
            {
                Header: 'Solicitante',
                className: 'pointer',
                accessor: 'nomeMembro',
            },
            {
                Header: 'Valor',
                accessor: 'valorPedido',
                // accessor: 'valorPago',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (<span>R$ {row.value !== undefined && row.value !== null ? row.value.toFixed(2).toString().replace('.', ',') : "0,00"}</span>)
            },
            {
                Header: 'Dt. pedido',
                accessor: 'dtPedido',
                className: 'pointer text-center',
                width: 150,
                Cell: row => (<span>{moment(row.value).format('DD/MM/YY HH:mm')}</span>)
            },
            {
                Header: 'Dt. pagto.',
                accessor: 'dtPagto',
                className: 'pointer text-center',
                width: 150,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: 'Qtd. Avulsos',
                accessor: 'qtdAvulsos',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (row.value ? row.value : 0)
            },
            {
                Header: 'Status pedido',
                accessor: 'statusPedido',
                className: 'text-center pointer',
                width: 110,
                Cell: row => (<span className={`badge badge-${this.orderBadgeType(row.value)}`}>{row.value}</span>)
            },
            {
                Header: 'Status pagto.',
                accessor: 'statusPagto',
                className: 'text-center pointer',
                width: 110,
                Cell: row => (<span className={`badge badge-${this.paymentBadgeType(row.value)}`}>{row.value}</span>)
            },

            {
                Header: 'Produto(s)',
                accessor: 'produto',
                className: 'text-center pointer',
                width: 120,
                Cell: row => (
                    row.value.map((item, index) => {
                        return <span key={index} className={`badge badge-${this.productBadgeType(item)} mx-1`}>{item}</span>
                    })
                )
            }
        ]

    }

    transformProductQueryObject(o) {
        const _new = []
        o.forEach(element => {
            const _item = this.productOptions.find(item => item.value === element);
            _new.push(_item);
        });

        return _new;
    }

    componentWillMount() {
        this.readQueryParams();
    }

    readQueryParams() {
        const _queries = qs.parse(window.location.search);
        // console.log('filters => ', _queries)

        if (_queries) {
            let _productList = [];

            if (_queries.products)
                _productList = this.transformProductQueryObject(_queries.products.length > 1 ? _queries.products : [_queries.products]);

            // if (_queries.products)
            //     _productList = this.transformProductQueryObject(_queries.products.length > 1 ? _queries.products : [_queries.products]);

            const _filters = update(this.state.filters, { $merge: { productList: _productList } });

            let page = 0;
            if (_queries.page) {
                page = _queries.page;
            }
            this.setState({ filters: _filters, page });
            // this.setState({ _filters: { productList: [{label: "Brasil Seikyo Português", value: "1"}]} });
        }
    }

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    refreshTable(o) {
        this.getOrders(o);
    }

    orderBadgeType(status) {
        switch (status.toLowerCase()) {
            case "pedido feito":
                return "primary";
            case "aguardando vigência":
                return "primary";
            case "vigência em andamento":
                return "primary";
            case "vencido":
                return "danger";
            case "pedido cancelado":
                return "danger";
            default:
                return "warning";
        }
    }

    paymentBadgeType(status) {
        switch (status.toLowerCase()) {
            case "pago":
                return "success";
            case "vencido":
                return "secondary";
            case "negado":
                return "danger";
            case "baixa manual":
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    productBadgeType(status) {
        switch (status) {
            case "BS":
                return "primary";
            case "TC":
                return "danger";
            case "RD":
                return "warning";
            default:
                return "info";
        }
    }

    handleSelectChange(e, o) {
        const _name = o.name;
        let _list = this.state.filters[_name];
        // console.log(o);
        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                //-- do
                break;
            case "clear":
                const _filters = this.state.filters;
                _filters[_name] = [];
                this.setState({
                    filters: _filters
                });
                return o;
            default:
                _list.push(o.option);
                break;
        }

        const _filters = update(this.state.filters, { $merge: { [_name]: _list } });
        this.setState({ _filters });

        return o;
    }

    getOrders(o) {
        this.setState({ loading: true });

        // console.log('_____ state _____', this.state.filters)

        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
            // this.setState({
            //     page: o.page
            // });
            o.sorted = []
            _params.push(`ordenacao=${o.sorted.map(item => item.id).join(',')}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
            this.setState({
                page: o.page + 1
            });
        }

        if (this.state.filters.paymentStatusList.length > 0) {
            _params.push(`statusPgto=${this.state.filters.paymentStatusList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.productList.length > 0) {
            _params.push(`idsProdutos=${this.state.filters.productList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.order.deliveryStartDate && this.state.filters.order.deliveryEndDate) {
            _params.push(`dtInicioEntrega=${moment(this.state.filters.order.deliveryStartDate).format()}`);
            _params.push(`dtFimEntrega=${moment(this.state.filters.order.deliveryEndDate).format()}`);
        }

        const _orders = axios.get(this.Configurations.apiBasePath + `/pedidos/avulsos?${_params.join('&')}`);

        const _parametros = _params.join('&');

        _orders.then(response => {
            this.setState({
                ordersList: response.data.data.pedidos,
                pages: response.data.data.paginacao.totalPaginas,
                loading: false,
                parametros: _parametros
            });
        }).catch(err => {
            console.log(err);
        });
    }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.deliveryStartDate = startDate;
            dates.deliveryEndDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    _outsideRange(day) {
        return false;//day.format() > moment().format();
    }

    toQueryString(obj) {
        return Object.keys(obj).filter((key) => obj[key] !== undefined && obj[key] !== '').reduce((str, key, i) => {
            var delimiter, val;
            delimiter = (i === 0) ? '?' : '&';
            if (Array.isArray(obj[key])) {
                key = encodeURIComponent(key);
                var arrayVar = obj[key].reduce((str, item) => {
                    val = encodeURIComponent(JSON.stringify(item));
                    return [str, key, '=', val, '&'].join('');
                }, '');
                return [str, delimiter, arrayVar.trimRightString('&')].join('');
            } else {
                key = encodeURIComponent(key);
                val = encodeURIComponent(JSON.stringify(obj[key]));
                return [str, delimiter, key, '=', val].join('');
            }
        }, '');
    }

    genPropsUrl(o) {
        // const _queries = qs.parse(window.location.search);
        const params = [];
        const delivery = qs.stringify(this.state.filters.order);
        if (delivery) params.push(delivery)
        const products = qs.stringify({
            products: this.state.filters.productList.map(item => {
                return item.value
            })
        });
        if (products) params.push(products)

        // let page = 0;
        // if (o.page) {
        //     page = 'page='+o.page;
        //     params.push(page)
        // } else if(_queries.page) {
        //     page = 'page='+_queries.page;
        //     params.push(page)
        // }
        const url = params.join('&');

        // console.log('__ url __', url);
        // console.log('__ json __', qs.parse(url));
        window.history.pushState("filterParams", "Editora Brasil Seikyo - Lista de Pedidos Avulsos", `?${url}`);
    }

    filterSearch(e) {
        e.preventDefault();
        this.genPropsUrl();
        this.getOrders({});
    }

    render() {
        return (
            <div className="gift-orders">
                <div className="row">
                    <div className="col-12">
                        <h2 className="title-1">Lista de avulsos</h2>
                    </div>
                    {/* <div className="col-12">
                        <pre>{JSON.stringify(this.state.page)}</pre>
                    </div> */}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header p-2" id="headingOne">
                                <div className="col-12">
                                    <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleFilters}>
                                        <i className={`fa mr-2 ${this.state.openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                        Filtros
                                    </button>
                                </div>
                            </div>
                            <div className={`card-body ${!this.state.openFilters && "collapse"}`} id="boxFilters">
                                {this.state.loading ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                        <form onSubmit={this.filterSearch} noValidate>
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="dpStartDate">Período de entrega</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            minimumNights={0}
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.order.deliveryStartDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.order.deliveryEndDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._orderDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.order.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._orderFocusChange}
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlProducts">Produtos</label>
                                                        <Select
                                                            id="ddlProducts"
                                                            placeholder="Selecione um ou mais produtos"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            isMulti
                                                            defaultValue={this.state.filters.productList}
                                                            options={this.productOptions}
                                                            onChange={this.handleSelectChange}
                                                            name="productList"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12 text-right">
                                                    <button className="btn btn-primary">Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.ordersList}
                                    columns={this.columns}
                                    onFetchData={this.refreshTable}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum pedido encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    getTrProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                this.props.history.push({ pathname: `/pedidos/detalhes/${rowInfo.original.numeroPedido}` })
                                            }
                                        }
                                    }}
                                    getPaginationProps={(o) => {
                                        this.genPropsUrl(o);
                                        return o;
                                    }}

                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SingleOrders;
